// Constants for FundSummaryParser to avoid magic strings

export const HEADER_ALIAS_PREFIX = 'header_';

// Class names
export const TABLE_HEADER_CLASS = 'table-header';
export const ROW_TOTAL_LABEL_CLASS = 'row-total-label';
export const ROW_LABEL_CLASS = 'row-label';

// Totals aliases
export const TOTALS_LABEL_ALIAS = 'totals_label';
export const TOTALS_EXIT_ALIAS = 'totals_exit';
export const TOTALS_PREV_ALIAS = 'totals_prev';
export const TOTALS_INVESTED_ALIAS = 'totals_invested';
export const TOTALS_MOIC_ALIAS = 'totals_moic';
export const TOTALS_IRR_ALIAS = 'totals_irr';

// Totals label text
export const TOTALS_LABEL_TEXT = 'Firm Total';

// Function names / formula helpers
export const SUM_FUNCTION_NAME = 'SUM';

// Default fallback column letters if a key is missing in the dynamic mapping
export const DEFAULT_COL_FOR_KEY: Record<string, string> = {
  entity: 'A',
  exitProceeds: 'B',
  previousProceeds: 'C',
  investedCapital: 'D',
  moic: 'E',
  irr: 'F',
};

